import { render, staticRenderFns } from "./CbrUpdatesChildItem.vue?vue&type=template&id=1badebb1&lang=pug&"
import script from "./CbrUpdatesChildItem.vue?vue&type=script&lang=js&"
export * from "./CbrUpdatesChildItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports